/**
 * アコーディオンメニュー
 */
jQuery( function ($) {
  $( '.menu-item-has-children span' ).on( 'click keydown', function(e) {
    if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") {
      return;
    }
    if ( ! window.matchMedia( '( min-width: 1000px )' ).matches ) {
      $( this ).parent( '.menu-item-has-children' ).toggleClass( 'is-open' ).children( '.sub-menu' ).slideToggle();
    }
  } );

  // リサイズ時にフッターナビゲーションはすべて表示
  let flag;
  if ( window.matchMedia('(min-width: 1000px)').matches ) {
    flag = 'pc';
  } else {
    flag = 'sp';
  }
  $( window ).on( 'resize', function () {
    if ( window.matchMedia( '( min-width: 1000px )' ).matches && flag !== 'pc' ) {
    $( '.menu-item-has-children' ).removeClass( 'is-open' ).children( '.sub-menu' ).hide();
    $( '.c-footernav .sub-menu' ).show();
    flag = 'pc';
    } else if ( flag !== 'sp' ) {
    $( '.menu-item-has-children' ).removeClass( 'is-open' ).children( '.sub-menu' ).hide();
    $( '.c-footernav .sub-menu' ).hide();
    flag = 'sp';
    }
  });
} );


jQuery( function ($) {
  $(document).on( 'click', '.js-accordion', function() {
    $(this).toggleClass( 'is-active' ).next( '.js-accordion-content' ).slideToggle();
  } );
} );

jQuery( function ($) {
  let openTimeout, closeTimeout;
  
  $('.c-gnav .menu-item-has-children').on('mouseenter focusin', function() {
      const _this = $(this); 
      clearTimeout(closeTimeout);
      if (window.matchMedia('(min-width: 1000px)').matches) {
        openTimeout = setTimeout(() => {
          $('.js-header').addClass('is-open');
          _this.addClass('is-open').children('.c-gnav__submenu').slideDown();
        }, 200);
      }
    }).on('mouseleave focusout', function() {
      const _this = $(this);
      clearTimeout(openTimeout);
      if (window.matchMedia('(min-width: 1000px)').matches) {
        closeTimeout = setTimeout(() => {
          _this.removeClass('is-open').children('.c-gnav__submenu').slideUp(() => {
            $('.js-header').removeClass('is-open');
          });
        }, 500);
      }
  });
});
  